<div [style.margin-left]="left" [style.height]="rowHeight">
  <div id="text" [style.width]="labelColumnWidth" [style.text-align]="textAlign">
    {{text}}
  </div>
  <div [style.width]="componentColumnWidth">
    <ng-content ></ng-content>
  </div>
</div>

